export enum SkillName {
  CampaignsManager = 'campaigns-manager',
  CampaignSetup = 'campaign-setup',
  CreativeTemplatesManager = 'creative-templates-manager',
  CreativesManager = 'creatives-manager',
  AdBuilder = 'ad-builder',
  TemplateMapping = 'template-mapping',
  CampaignAnalytics = 'campaign-analytics',
  BrandGuidelines = 'brand-guidelines',
  AccountAnalytics = 'account-analytics',
  ContentFeedAiGenerated = 'content-feed-ai-generated',
  Support = 'support',
  GeneralNavigation = 'general-navigation',
}

export enum SkillXmlTag {
  ActiveSkills = 'active-skills',
  ActiveSkillsInConversation = 'active-skills-in-conversation',
  AvailableSkills = 'available-skills',
  Skill = 'skill',
  Guidelines = 'guidelines',
  Instructions = 'instructions',
  UiContext = 'ui-context',
  UserLocation = 'user-location',
  ConversationSummary = 'conversation-summary',
  RecentConversation = 'recent-conversation',
  UploadedFiles = 'uploaded-files',
}
